export interface User {
  id?: string
  emailConfirmed?: boolean
  created?: number
  affiliations?: Affiliation[]
}

export interface UaO {
  loginId?: string
  orgId?: string
  orgType?: OrganizationType
  role?: UserRole
  user?: User
  created?: number
}

export interface Affiliation {
  organizationId?: string
  role?: UserRole
}

export type UserRole =
  'SYSTEM' |
  'SYSTEM_ADMIN' |
  'ADMIN' |
  'EDITOR' |
  'READER' |
  'NONE'
export const USER_ROLE_DEF: EnumDef = Object.freeze({
  id: 'jps-user_role',
  c: {
    SYSTEM: {
      l: {
        ja: 'システム',
        en: 'System'
      },
      d: {}
    },
    SYSTEM_ADMIN: {
      l: {
        ja: 'システム管理者',
        en: 'System Administrator'
      },
      d: {}
    },
    ADMIN: {
      l: {
        ja: '組織管理者',
        en: 'Organization Administrator'
      },
      d: {}
    },
    EDITOR: {
      l: {
        ja: '編集権限',
        en: 'Editor'
      },
      d: {}
    },
    READER: {
      l: {
        ja: '閲覧権限',
        en: 'Reader'
      },
      d: {}
    },
    NONE: {
      l: {
        ja: '権限無し',
        en: 'None'
      },
      d: {}
    }
  }
})
